import type { EmployeePolicy } from "Utils/types";

export const isDeclinedCompletedPolicy = (employeePolicy: EmployeePolicy) => {
  const enrollingAny = ["isEnrolling", "isEnrollingDental", "isEnrollingVision"].some((enrollingProp) => employeePolicy[enrollingProp] === "Yes");

  return !enrollingAny && !!employeePolicy.effectiveAt;
};
